import { render, staticRenderFns } from "./list-sinisters-provider.vue?vue&type=template&id=60604a5c"
import script from "./list-sinisters-provider.vue?vue&type=script&lang=js"
export * from "./list-sinisters-provider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports